import { combineReducers } from 'redux';
import { SubmissionTypeTypes } from '../../action_types';

import { handleRequest, initialRequestState } from './helpers';

function getSubmissionTypes(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.GET_SUBMISSION_TYPES_REQUEST,
    SubmissionTypeTypes.GET_SUBMISSION_TYPES_SUCCESS,
    SubmissionTypeTypes.GET_SUBMISSION_TYPES_FAIL,
    state,
    action
  );
}

function filterSubmissionTypes(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.FILTER_SUBMISSION_TYPES_REQUEST,
    SubmissionTypeTypes.FILTER_SUBMISSION_TYPES_SUCCESS,
    SubmissionTypeTypes.FILTER_SUBMISSION_TYPES_FAIL,
    state,
    action
  )
}

function getSubmissionType(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.GET_SUBMISSION_TYPE_REQUEST,
    SubmissionTypeTypes.GET_SUBMISSION_TYPE_SUCCESS,
    SubmissionTypeTypes.GET_SUBMISSION_TYPE_FAIL,
    state,
    action
  );
}

function updateActiveAllSubmissionType(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ACTIVE_ALL_SUBMISSION_TYPE_REQUEST,
    SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ACTIVE_ALL_SUBMISSION_TYPE_SUCCESS,
    SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ACTIVE_ALL_SUBMISSION_TYPE_FAIL,
    state,
    action
  )
}

function updateSubmissionType(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.UPDATE_SUBMISSION_TYPE_REQUEST,
    SubmissionTypeTypes.UPDATE_SUBMISSION_TYPE_SUCCESS,
    SubmissionTypeTypes.UPDATE_SUBMISSION_TYPE_FAIL,
    state,
    action
  );
}

function getOrgSubmissionTypes(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.GET_ORG_SUBMISSION_TYPES_REQUEST,
    SubmissionTypeTypes.GET_ORG_SUBMISSION_TYPES_SUCCESS,
    SubmissionTypeTypes.GET_ORG_SUBMISSION_TYPES_FAIL,
    state,
    action
  );
}

function filterOrgSubmissionTypes(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.FILTER_ORG_SUBMISSION_TYPES_REQUEST,
    SubmissionTypeTypes.FILTER_ORG_SUBMISSION_TYPES_SUCCESS,
    SubmissionTypeTypes.FILTER_ORG_SUBMISSION_TYPES_FAIL,
    state,
    action
  )
}

function updateOrgSubmissionTypes(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPES_REQUEST,
    SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPES_SUCCESS,
    SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPES_FAIL,
    state,
    action
  )
}

function updateOrgSubmissionType(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPE_REQUEST,
    SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPE_SUCCESS,
    SubmissionTypeTypes.UPDATE_ORG_SUBMISSION_TYPE_FAIL,
    state,
    action
  );
}

function superAdminGetOrgSubmissionTypes(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.SUPER_ADMIN_GET_ORG_SUBMISSION_TYPES_REQUEST,
    SubmissionTypeTypes.SUPER_ADMIN_GET_ORG_SUBMISSION_TYPES_SUCCESS,
    SubmissionTypeTypes.SUPER_ADMIN_GET_ORG_SUBMISSION_TYPES_FAIL,
    state,
    action
  );
}

// function superAdminFilterOrgSubmissionTypes(state = initialRequestState(), action) {
//   return handleRequest(
//     SubmissionTypeTypes.SUPER_ADMIN_FILTER_ORG_SUBMISSION_TYPES_REQUEST,
//     SubmissionTypeTypes.SUPER_ADMIN_FILTER_ORG_SUBMISSION_TYPES_SUCCESS,
//     SubmissionTypeTypes.SUPER_ADMIN_FILTER_ORG_SUBMISSION_TYPES_FAIL,
//     state,
//     action
//   )
// }

function superAdminUpdateOrgSubmissionType(state = initialRequestState(), action) {
  return handleRequest(
    SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ORG_SUBMISSION_TYPE_REQUEST,
    SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ORG_SUBMISSION_TYPE_SUCCESS,
    SubmissionTypeTypes.SUPER_ADMIN_UPDATE_ORG_SUBMISSION_TYPE_FAIL,
    state,
    action
  );
}

export default combineReducers({
  getSubmissionTypes,
  filterSubmissionTypes,
  getSubmissionType,
  updateOrgSubmissionTypes,
  updateActiveAllSubmissionType,
  updateSubmissionType,
  getOrgSubmissionTypes,
  filterOrgSubmissionTypes,
  updateOrgSubmissionType,
  superAdminGetOrgSubmissionTypes,
  // superAdminFilterOrgSubmissionTypes,
  superAdminUpdateOrgSubmissionType,
});
